





































import { Component, Prop, Vue } from 'vue-property-decorator'
import { AssignmentGroup } from '@/services/browse-and-go/assignment-view'

@Component({
  name: 'BrowseAndGoAssignmentGroups'
})
export default class extends Vue {
  @Prop({ required: true }) private groups!: AssignmentGroup[]
  @Prop({ default: '' }) private empty!: string
}
